import colors from "../tokens/_colors.module.scss"

export const cluxColors = [
  colors.purple,
  colors.pink,
  colors.yellow,
  colors.blue,
  colors.green,
]
